import { render, staticRenderFns } from "./CallBack.vue?vue&type=template&id=2f6f7049&scoped=true"
import script from "./CallBack.vue?vue&type=script&lang=js"
export * from "./CallBack.vue?vue&type=script&lang=js"
import style0 from "./CallBack.vue?vue&type=style&index=0&id=2f6f7049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f7049",
  null
  
)

export default component.exports